import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
      data-product-shop
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className={`relative overflow-hidden rounded-lg bg-background-100 ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[2/3]'
      }`}>
        <img
          src={comic.coverImage}
          alt={`皮皮漫画${comic.title}`}
          title={`皮皮漫画${comic.title}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {comic.isHot && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-background-50 rounded-full">
              热门
            </span>
          )}
          {comic.isNew && (
            <span className="px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-background-50 rounded-full">
              新作
            </span>
          )}
        </div>
        {comic.status === '已完结' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-[10px] font-medium bg-secondary-700 text-background-50 rounded-full">
              {comic.status}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-sm font-medium text-white line-clamp-1 group-hover:text-primary-300 transition-colors">
            {comic.title}
          </p>
          <div className="flex items-center gap-2 mt-1">
            <span className="text-[11px] text-white/70">{comic.author}</span>
            <span className="text-[11px] text-accent-400">
              ★ {comic.rating}
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
}